var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('navbar',{attrs:{"text":((_vm.$t('Configuration.name')) + " > " + (_vm.$t('DxTools_Title')))}}),_vm._v(" "),_c('DxToolsDatabase')],1)}
var staticRenderFns = []

export { render, staticRenderFns }